module.exports = __webpack_public_path__ + "img/liucheng.eea76da7.png";